module.exports = __webpack_public_path__ + "img/Au_ASU_parternship.e3a9ff60.jpg";